import React, { useMemo, useRef } from "react";

import { HvDropdownProps } from "@hitachivantara/uikit-react-core";

import { IncidentType } from "lib/api";
import { Icon } from "components/common";
import BaseDropdown from "../BaseDropdown";

import useStyles from "./styles";

interface IncidentTypeDropdownProps extends Omit<HvDropdownProps, "values"> {
  types?: IncidentType[];
  defaultValue?: number;
}

const IncidentTypeDropdown = ({
  types,
  defaultValue,
  ...other
}: IncidentTypeDropdownProps): JSX.Element => {
  const classes = useStyles();
  const initialSelectedRef = useRef(defaultValue);

  const dropdownValues = useMemo(
    () =>
      types?.map((r) => {
        return {
          id: r.pk_inc_type_id.toString(),
          label:
            r?.appearance?.icon_type && r.appearance.icon_type !== "none" ? (
              <>
                <div role="presentation" className={classes.iconContainer}>
                  <Icon iconData={r.appearance} color={r?.appearance.color} />
                </div>
                <span className={classes.textContainer}>{r.inc_type_name}</span>
              </>
            ) : (
              <span className={classes.noIconTextContainer}>
                {r.inc_type_name}
              </span>
            ),
          searchValue: r.inc_type_name,
          selected:
            initialSelectedRef.current != null
              ? initialSelectedRef.current === r.pk_inc_type_id
              : false,
        };
      }),
    [
      classes.iconContainer,
      classes.noIconTextContainer,
      classes.textContainer,
      types,
      initialSelectedRef,
    ]
  );

  return (
    <BaseDropdown
      classes={{
        placeholder: classes.placeholder,
      }}
      values={dropdownValues}
      {...other}
    />
  );
};

export default IncidentTypeDropdown;
